import type DetailsState from "..";
import {Action} from "../../../action/action";

export const SET_PARKING_TEXT = "SET_PARKING_TEXT";
export class SetParkingText extends Action<typeof SET_PARKING_TEXT, string> {
  readonly type = SET_PARKING_TEXT;
  protected state: DetailsState;

  constructor(state: DetailsState, parkingText?: string | undefined) {
    super(state, parkingText);
    this.state = state;
  }
  /**
   * If product if either Package or CompanyLead this action should not be available
   * @returns
   */
  public isDoable(): boolean {
    const product = this.state.product;
    const isProductABooking = product.type == "Package" || product.type == "CompanyLead";
    return !isProductABooking;
  }
  public isValid(): boolean {
    return this.isDoable();
  }
}
